export default (key, selector, initialState) => (store) => {
	if (!store[key]) {
		return selector(initialState);
	}
	return selector(store[key]);
};
